module.exports = __webpack_public_path__ + "static/media/promo25bikes.3fd2d11f.png";